import React, { Component } from "react";
import ReactGA from "react-ga";
import $ from "jquery";
import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Services from "./Components/Services";
import Contact from "./Components/Contact";
import Portfolio from "./Components/Portfolio";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      foo: "bar",
      sanData: {}
    };

    ReactGA.initialize("UA-110570651-1");
    ReactGA.pageview(window.location.pathname);
  }

  getSanData() {
    $.ajax({
      url: "./sanData.json",
      dataType: "json",
      cache: false,
      success: function(data) {
        this.setState({ sanData: data });
      }.bind(this),
      error: function(xhr, status, err) {
        console.log(err);
        alert(err);
      }
    });
  }

  componentDidMount() {
    this.getSanData();
  }

  render() {
    return (
      <div className="App">
        <Header data={this.state.sanData.main} />
        <About data={this.state.sanData.main} />
        <Services data={this.state.sanData.services} />
        <Portfolio data={this.state.sanData.portfolio} />
        <Contact data={this.state.sanData.main} />
        <Footer data={this.state.sanData.main} />
      </div>
    );
  }
}

export default App;
